import { getV2PortalUrl } from "services/v2Portal";

const V1LockoutScreen = () => {
  const portalUrl = getV2PortalUrl();
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-6 p-8 text-center">
      <img
        className="max-w-[200px] object-contain"
        src="/stormtech_icon_placeholder.svg"
        alt="Stormtech"
      />
      <h1 className="text-2xl font-bold">Your account has moved to the new Stormtech platform</h1>
      <p className="max-w-md text-base">
        You are now set up on the new platform. Please continue there. This older
        version is no longer available for your account.
      </p>
      <a
        href={portalUrl}
        className="rounded bg-st-orange px-6 py-3 text-base font-bold text-white"
      >
        Go to the new platform
      </a>
    </div>
  );
};

export default V1LockoutScreen;
